module.exports = __webpack_public_path__ + "img/top_single.8fd2daa0.jpg";